module.exports = __webpack_public_path__ + "static/img/mp3.6857d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/mp3.png
// module id = p13q
// module chunks = 1